import { useTranslation } from 'react-i18next';
import {
  Column,
  ContentContainer,
  ContentWrapper,
  FormWrapper,
  Heading,
  LabelKey,
  LabelKeyWrapper,
  LabelValue,
  LeftSide,
  RightSide,
  RowSpaceBetween,
  Subtitle,
  ValueWrapperRelative,
} from './CompanyConfigurationCard.styled';
import LogoCard from '../LogoCard/LogoCard';
import { PencilSimple } from '@phosphor-icons/react';
import { COLORS } from 'assets/styled';
import Icon from 'components/Icon/Icon';

interface ICompanyConfigurationCardProps {
  cardTitle: string;
  leftSubtitle?: string;
  rightSubtitle?: string;
  leftData: object;
  rightData: object;
  onEditClick?: () => void;
  isLoading?: boolean;
  companyId?: number;
  logoUrl?: string;
  hasLogoCard?: boolean;
}

export const CompanyConfigurationCard = ({
  cardTitle,
  leftSubtitle,
  rightSubtitle,
  leftData,
  rightData,
  onEditClick,
  logoUrl,
  hasLogoCard,
}: ICompanyConfigurationCardProps) => {
  const { t } = useTranslation();

  return (
    <ContentContainer>
      <RowSpaceBetween>
        <Heading>{cardTitle}</Heading>
        <ValueWrapperRelative>
          <Icon
            svg={PencilSimple}
            color={COLORS.GREEN}
            size={25}
            onClick={onEditClick}
          />
        </ValueWrapperRelative>
      </RowSpaceBetween>

      <ContentWrapper>
        <LeftSide>
          <div>
            {leftSubtitle && <Subtitle>{leftSubtitle.toUpperCase()}</Subtitle>}
            <FormWrapper>
              {Object.keys(leftData).map((dataKey: string, index: number) => (
                <Column key={index}>
                  <LabelKeyWrapper>
                    <LabelKey>{t(dataKey)}</LabelKey>
                  </LabelKeyWrapper>

                  {leftData[dataKey] && (
                    <div>
                      <LabelValue>{leftData[dataKey]}</LabelValue>
                    </div>
                  )}
                </Column>
              ))}
            </FormWrapper>
          </div>
        </LeftSide>

        <RightSide>
          <div>
            {rightSubtitle && (
              <Subtitle>{rightSubtitle.toUpperCase()}</Subtitle>
            )}
            <FormWrapper>
              {Object.keys(rightData).map((dataKey: string, index: number) => (
                <Column key={index}>
                  <LabelKeyWrapper>
                    <LabelKey>{t(dataKey)}</LabelKey>
                  </LabelKeyWrapper>

                  {rightData[dataKey] && (
                    <div>
                      <LabelValue>{rightData[dataKey]}</LabelValue>
                    </div>
                  )}
                </Column>
              ))}
            </FormWrapper>
          </div>
        </RightSide>
      </ContentWrapper>
      {hasLogoCard && <LogoCard logoUrl={logoUrl || ''} />}
    </ContentContainer>
  );
};
